/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { Divider, Typography, Typography2 } from '@coursera/cds-core';

const styles = {
  container: css`
    justify-content: center;
    display: flex;
    flex-direction: column;
  `,
  title: (theme: Theme) => css`
    margin-bottom: ${theme.spacing(4)};
  `,
  divider: (theme: Theme) => css`
    margin: ${theme.spacing(8, 0)};
    height: 2px;
  `,
  subsection: (theme: Theme) => css`
    margin-top: ${theme.spacing(16)};
  `,
};

type Props = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  instructors?: React.ReactNode;
  reviews?: React.ReactNode;
  cta?: React.ReactNode;
};

const SecondaryInfo: React.FC<Props> = ({ title, subtitle, instructors, reviews, cta }) => {
  return (
    <div css={styles.container}>
      <div css={styles.title}>
        <Typography variant="h2semibold">{title}</Typography>
      </div>
      <div>
        <Typography2 component="p" color="supportText" variant="bodySecondary">
          {subtitle}
        </Typography2>
      </div>
      <Divider css={styles.divider} />
      {instructors && <div>{instructors}</div>}
      {Boolean(reviews) && <div css={styles.subsection}>{reviews}</div>}
      {cta && <div css={styles.subsection}>{cta}</div>}
    </div>
  );
};

export default SecondaryInfo;
